import { RotateCw, TriangleAlert } from "lucide-react";

import { Button } from "@/ui";

import styles from "./ErrorScreen.module.css";

export interface ErrorScreenProps {
  title: string;
  detail?: string;
  onRetry?: () => void;
}

export function ErrorScreen({ title, detail, onRetry }: ErrorScreenProps) {
  return (
    <main className={styles.screen}>
      <div className={styles.card} role="alert">
        <TriangleAlert aria-hidden="true" className={styles.icon} />
        <h1 className={styles.title}>{title}</h1>
        {detail !== undefined && <pre className={styles.detail}>{detail}</pre>}
        {onRetry !== undefined && (
          <Button variant="primary" icon={<RotateCw />} onClick={onRetry}>
            Try again
          </Button>
        )}
      </div>
    </main>
  );
}
